// extracted by mini-css-extract-plugin
export default {"myTabs":"tabs_myTabs__+NbNe","badge":"tabs_badge__FOA4I","badge-yellow":"tabs_badge-yellow__CeQ2G","badge-green":"tabs_badge-green__U85GY","badge-red":"tabs_badge-red__6ng03"};